// Generated from Membership's `required_filter_groups` — do not edit.

import type {FilterDefinitionMapping} from '../../boot/hooks/useApi'
import type {Iri} from '../Api'

export type MembershipCollectionFilterGroups
  = | {
    readonly spot: Iri | Iri[]
  }
  | {
    readonly user: Iri | Iri[]
  }

export const membershipCollectionFilterMapping: FilterDefinitionMapping<MembershipCollectionFilterGroups> = {
  spot: 'spot',
  user: 'user',
}

export type MembershipCollectionSort = 'user.name' | 'role'

export type MembershipAdminCollectionFilterGroups
  = | {
    readonly spot: Iri | Iri[]
  }
  | {
    readonly user: Iri | Iri[]
  }

export const membershipAdminCollectionFilterMapping: FilterDefinitionMapping<MembershipAdminCollectionFilterGroups> = {
  spot: 'spot',
  user: 'user',
}

export type MembershipAdminCollectionSort = 'user.name' | 'role'
